import { useModal } from '~/composables/common/use-modal'
import { ModalCollection } from '~/constants'

const SECTION_KEY = 'hasShownEventPopup'

export const useModalWelcome = () => {
  const { openModal, closeModal } = useModal()

  const initModal = () => {
    const hasModalWelcome = sessionStorage.getItem(SECTION_KEY)

    if (hasModalWelcome) return
    openModalEvent()
  }

  const openModalEvent = () => {
    openModal(ModalCollection.PREMIER_LEAGUE_RANKING)
    sessionStorage.setItem(SECTION_KEY, 'true')
  }

  const closeModalEvent = () => {
    closeModal(ModalCollection.PREMIER_LEAGUE_RANKING)
    sessionStorage.setItem(SECTION_KEY, 'false')
  }

  return {
    initModal,
    openModalEvent,
    closeModalEvent
  }
}
